import { render, staticRenderFns } from "./detail-info-table.vue?vue&type=template&id=ef5e249e&scoped=true&"
import script from "./detail-info-table.vue?vue&type=script&lang=js&"
export * from "./detail-info-table.vue?vue&type=script&lang=js&"
import style0 from "./detail-info-table.vue?vue&type=style&index=0&id=ef5e249e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5e249e",
  null
  
)

export default component.exports